$(() => {
    try {
        $.mask.definitions["_"] = "[0-9]";
        $(".input-phone").mask("+ 7 (___) ___ - __ - __");
    } catch (error) { }
});
